import { getMessageFromFormErrors } from "helper/error"

export default function InputFrame(props) {

    const errors = props.form.formState.errors
    const field = props.controller.field
    const service = props?.service || false
    const partsName = field.name.split('.')
    const justName = partsName[partsName.length - 1]
    const required = service.requiredFields && service.requiredFields.includes(justName)
    const children = props.children
    const requiredColor = required ? '' : ''

    const getFormErrorMessage = (name) => {
        const message = getMessageFromFormErrors(errors, name)
        return message ? <small className="p-error">{message}</small> : <small className="p-error"></small>
    }

    const withLabel = <label htmlFor={field.name} className={`mb-1 text-sm ${requiredColor} ${props.className}`} >{props.label} {(required && <a className={'text-red-500'}>*</a>)} </label >

    const noLabel = <div>&nbsp;</div>

    return (
        <>
            {props?.hiddenLabel ? noLabel : withLabel}
            {children}
            {getFormErrorMessage(field.name)}
        </>
    )
}
